<template>
    <div>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <v-img
            src='../assets/Prices/Cennik.png'
            :height="picheight"
            ></v-img>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-12 align-center justify-center text-h6">                
          Kup kołdrę na raty z pomocą <v-img height="40" max-width="120" src='../assets/Shop/Przelewy24_logo.png'></v-img>
        </v-row>
        <v-row class="mt-8 mx-16 text-center">
          <v-col cols="12">
            <p class="text-subtitle-1">Zapraszamy do zakupu w zakładce "Sklep"!</p>
            <p class="text-subtitle-1"><v-btn color="primary" @click="$router.push('/sklep_koldry')">Nasze kołdry</v-btn></p>
          </v-col>
        </v-row>
        <br />
    </div>
</template>

<script>
  export default {
    data () {
      return {
        mobile: '',
        picheight: '1000'
      }
    },
    created() {
      this.mobile = this.$vuetify.display.mobile
      if(this.mobile == true) {
        this.picheight = '500'
      } else {
        this.picheight = '1000'
      }
    }
  }
</script>